import React from 'react'
import Image from 'next/image'
import Link from 'next/link'
import styled from '@emotion/styled'
import { DateTime } from 'luxon'
import { gsColors as c } from '../../styles/Variables'

const BylineWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;

  .byline-headshot {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    overflow: hidden;
    flex-shrink: 0;
    position: relative;

    img {
      object-fit: cover;
      object-position: center 0;
    }
  }

  p {
    margin: 0;
    font-family: Euclid;
    font-size: 16px;
    color: ${c.darkGrey};
    font-weight: 400;
    line-height: 138%;
  }

  a {
    color: inherit;
    text-decoration: underline;
  }
`

/**
 * Blog post byline: headshot, then "By <name>, <title> at Glamsquad." followed
 * by "Published <Month D, YYYY>." when the post has a publish date.
 *
 * @param {{ author: object, publishDate?: string }} props - publishDate is the
 *   Strapi `publish_date` (YYYY-MM-DD)
 */
export default function AuthorByline({ author, publishDate }) {
  if (!author) {
    return null
  }

  const published = publishDate ? DateTime.fromISO(publishDate) : null

  return (
    <BylineWrapper>
      <div className="byline-headshot">
        <Image
          src={author.headshot}
          alt={author.name}
          fill
        />
      </div>
      <p>
        By <Link href={`/author/${author.slug}`}>{author.name}</Link>, {author.title} at Glamsquad.
        {published?.isValid && ` Published ${published.toFormat('LLLL d, yyyy')}.`}
      </p>
    </BylineWrapper>
  )
}
